import { useEffect } from "react";
import SideBar from "../../components/AdminDashboard/SideBar";
import "../../styles/AdminDashboard/Home.scss";
import Chart from "chart.js/auto";
import { useState } from "react";
import {
  getEmissionHistoryByFacility,
  getTotalUsers,
  getTotalValidators,
  getUsers,
  getWeeklyEmission,
  registerGreenDevice,
  registerNonGreenDevice,
} from "../../apis/AdminDashboard/users";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getPlantsData as greenBasicGetAllEmissionData,
} from "../../instantiateTransaction/basicGreenProject";
import {
  getPlantsData as infraBasicGetAllEmissionData,
} from "../../instantiateTransaction/basicInfrastructureChange";
import {
  getPlantsData as greenGovernanceGetAllEmissionData,
} from "../../instantiateTransaction/governanceGreenProject";

import {
  getPlantsData as governanceInfraGetAllEmissionData,
} from "../../instantiateTransaction/gorvernanceInfrastructureChange";

import {
  getPlantsData as governanceMonitoringGetAllEmissionData,
} from "../../instantiateTransaction/governanceCarbonMonitoring";

// Business subscription imports with proper aliases
import {
  getPlantsData as businessGreenGetAllEmissionData,
} from "../../instantiateTransaction/businessGreen";
import {
  getPlantsData as businessInfraGetAllEmissionData,
} from "../../instantiateTransaction/businessInfrastructureChange";
import {
  getPlantsData as businessMonitoringGetAllEmissionData,
} from "../../instantiateTransaction/businessCarbonMonitoring";

import { ethers } from "ethers";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Search from "../../components/AdminDashboard/Search";
import { getDatabase, ref, onValue, push } from "firebase/database";

const Home = () => {
  const auth = useSelector((state) => state.auth);
  console.log("auth", auth);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [emissionLoading, setEmissionLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalValidators, setTotalValidators] = useState(0);
  const [users, setUsers] = useState([]);
  const [organization, setOrganization] = useState("");
  const [fuelType, setFuelType] = useState("");
  const [solarType, setSolarType] = useState("");
  const [scenario, setScenario] = useState("");
  const [sensorId, setSensorId] = useState("");
  const [emissions, setEmissions] = useState([]);
  const [emissionsStatic, setEmissionsStatic] = useState([]);
  const [weeklyEmission, setWeeklyEmssion] = useState([]);
  const [weeklyEmissionDays, setWeeklyEmissionDays] = useState([]);
  const [userType, setUserType] = useState("basic");
  const [offsets, setOffsets] = useState([]);
  const [getUsersLoading, setGetUsersLoading] = useState(false);
  const [renewableSource, setRenewableSource] = useState("");
  const [baselineEnergySource, setBaselineEnergySource] = useState("");

  const db = getDatabase();

  const getEmissions = async () => {
    setEmissionLoading(true);
    try {
      const temp = [];

      const response6 = await greenBasicGetAllEmissionData(0, 20);
      console.log("response6", response6);
      temp.push(...response6?.getAllInfo);
      setEmissions([...temp]);
      setEmissionsStatic([...temp]);

      const response7 = await infraBasicGetAllEmissionData(0, 20);
      console.log("response7", response7);
      temp.push(...response7?.getAllInfo);
      setEmissions([...temp]);
      setEmissionsStatic([...temp]);

      const response8 = await greenGovernanceGetAllEmissionData(0, 20);
      console.log("response8", response8);
      temp.push(...response8?.getAllInfo);
      setEmissions([...temp]);
      setEmissionsStatic([...temp]);

      const response9 = await governanceInfraGetAllEmissionData(0, 20);
      console.log("response9", response9);
      temp.push(...response9?.getAllInfo);
      setEmissions([...temp]);
      setEmissionsStatic([...temp]);

      const response10 = await governanceMonitoringGetAllEmissionData(0, 20);
      temp.push(...response10?.getAllInfo);
      setEmissions([...temp]);

      const response11 = await businessGreenGetAllEmissionData(0, 20);
      temp.push(...response11?.getAllInfo);
      setEmissions([...temp]);

      const response12 = await businessInfraGetAllEmissionData(0, 20);
      temp.push(...response12?.getAllInfo);
      setEmissions([...temp]);
      const response13 = await businessMonitoringGetAllEmissionData(0, 20);
      temp.push(...response13?.getAllInfo);
      setEmissions([...temp]);

      setEmissionsStatic([...temp]);


    } catch (error) {
      console.log("ERROR", error);
      // toast.error("Something went wrong");
    }
    setEmissionLoading(false);
  };

  useEffect(() => {
    getEmissions();
  }, []);

  useEffect(() => {
    console.log('labile', emissions);
  }, [emissions]);

  const handleGetWeeklyEmissions = async () => {
    const response = await getWeeklyEmission(auth?.token);
    console.log('timeless', response);
    setWeeklyEmssion(
      response?.data?.message?.map((item) =>
        Number(item?.totalEmission)?.toFixed(5)
      )
    );
    const temp = response?.data?.message?.map((item) => {
      const date = new Date(Number(item.createdAt));
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[date.getMonth()];
      const day = date.getDate();
      return `${month} ${day}`;
    });
    setWeeklyEmissionDays(temp);
  };

  useEffect(() => {
    handleGetWeeklyEmissions();
  }, []);

  useEffect(() => {
    const doughnut = document.getElementById("doughnutChart");

    const doughnutChart = new Chart(doughnut, {
      type: "doughnut",
      data: {
        // labels: ["Stationary Emissions"],
        datasets: [
          {
            label: ["Carbon incentive"],
            data: [20, 90],
            borderWidth: 1,
            backgroundColor: ["#70A625", "#85D772"],
          },
        ],
      },
    });

    return () => doughnutChart.destroy();
  }, []);

  const handleGetEmissionHistoryByFacility = async () => {
    const response = await getEmissionHistoryByFacility(auth?.token, "anual");
    console.log("handleGetEmissionHistoryByFacility", response);
    if (response?.data?.statusCode === 200) {
      setOffsets(response?.data?.message);
    }
  };

  useEffect(() => {
    handleGetEmissionHistoryByFacility();
  }, []);

  const handleFilterEmissions = () => {
    if (status === "pending") {
      const temp = emissionsStatic.filter(
        (emission) =>
          !emission?.isValidated &&
          !emission?.isRejected
      );
      setEmissions(temp);
    } else if (status === "approved") {
      const temp = emissionsStatic.filter(
        (emission) =>
          !!emission?.isValidated
      );
      setEmissions(temp);
    } else if (status === "rejected") {
      const temp = emissionsStatic.filter(
        (emission) =>
          !!emission?.isRejected
      );
      setEmissions(temp);
    }
  };

  useEffect(() => {
    handleFilterEmissions();
  }, [status]);

  const getAllUsersAndValidators = async () => {
    const response = await getTotalUsers(auth?.token);
    console.log('total users', response);
    const response3 = await getTotalValidators(auth?.token);
    console.log('response3', response3);
    setTotalUsers(response?.data?.total);
    setTotalValidators(response3?.data?.message);

  };

  const getPlatformUsers = async () => {
    setGetUsersLoading(true)
    const response2 = await getUsers(userType, auth?.token);
    console.log('the users', response2);
    const filteredUsers = response2?.data?.users?.filter(
      (user) => user?.user === "user" && user?.role === "user" && !!user?.companyName
    );
    // console.log("filteredUsers", filteredUsers);
    setUsers(filteredUsers?.reverse());
    setGetUsersLoading(false)

  }

  useEffect(() => {
    getPlatformUsers();
  }, [userType])

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = (e) => {
    if (e.target.classList.contains("sensor_modal")) {
      setModalOpen(false);
    }
  };

  useEffect(() => {
    const ctx = document.getElementById("total_emission");

    const myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: weeklyEmissionDays,
        datasets: [
          {
            label: "Emission Tracked",
            data: weeklyEmission,
            borderWidth: 1,
            backgroundColor: "#FA9874",
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                return `${tooltipItem?.label}`;
              },
              label: function (tooltipItem) {
                return `${tooltipItem?.formattedValue}kg`;
              },
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });

    return () => myChart.destroy();
  }, [weeklyEmission, weeklyEmissionDays]);

  useEffect(() => {
    getAllUsersAndValidators();
  }, []);

  const handleClearForm = () => {
    setOrganization("");
    setFuelType("");
    setSolarType("");
    setScenario("");
    setRenewableSource("");
    setBaselineEnergySource("");
  };

  const handleRegisterDevice = async () => {
  setLoading(true);
  if (organization === "") {
    alert("Please select an organisation");
  } else if (scenario === "") {
    alert("Please select a facility type");
  } else if (scenario === "green-project" && baselineEnergySource === "") {
    alert("Please select a baseline energy source");
  } else if (scenario === "green-project" && renewableSource === "solar" && solarType === "") {
    alert("Please select a solar type");
  } else if (scenario === "carbon-monitoring" && fuelType === "") {
    alert("Please select a fuel type");
  } else if (scenario === "infrastructure-change" && fuelType === "") {
    alert("Please select a fuel type");
  } else {
    if (scenario === "green-project") {
      const response = await registerGreenDevice({
        token: auth.token,
        id: organization,
        facilityType: scenario,
        solarType: solarType,
        renewableSource: renewableSource,
        fuelType: baselineEnergySource, // This is what backend expects
      });
      console.log('response', response);

      if (response?.data?.statusCode === 200) {
        setSensorId(response?.data?.deviceId);
        handleModalOpen();
        handleClearForm();
        push(ref(db, "notifications"), {
          type: "IoT registered",
          read: false,
          user: organization,
          timestamp: Date.now(),
        });
      } else {
        toast.error("Something went wrong");
      }
    } else if (
      scenario === "infrastructure-change" ||
      scenario === "carbon-monitoring"
    ) {
      const response = await registerNonGreenDevice(
        scenario,
        fuelType,
        organization,
        auth?.token
      );

      console.log('response', response);
      if (response?.data?.statusCode === 200) {
        setSensorId(response?.data?.deviceId);
        handleModalOpen();
        handleClearForm();
      } else {
        toast.error("Something went wrong");
      }
    }
  }
  setLoading(false);
};
  return (
    <div className="admin_home">
      <div className="sidebar_container">
        <SideBar />
      </div>

      <div className="main">
        <Search />
        <div className="main_inner">
          <div className="admin_card_group">
            <div className="card">
              <div className="title">Users</div>
              <div className="value_group">
                <div className="value">{totalUsers}</div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9921 14.8051C11.9973 14.1359 12.7605 13.161 13.1687 12.0245C13.577 10.888 13.6087 9.65036 13.2591 8.49449C12.9095 7.33862 12.1973 6.32593 11.2276 5.60617C10.258 4.88642 9.0825 4.4978 7.87492 4.4978C6.66735 4.4978 5.49184 4.88642 4.52221 5.60617C3.55258 6.32593 2.84032 7.33862 2.49076 8.49449C2.1412 9.65036 2.17288 10.888 2.58114 12.0245C2.9894 13.161 3.75255 14.1359 4.75774 14.8051C2.93945 15.4752 1.38659 16.7154 0.330862 18.3404C0.275377 18.4229 0.236837 18.5155 0.217482 18.613C0.198127 18.7105 0.198344 18.8109 0.218119 18.9083C0.237895 19.0057 0.276835 19.0982 0.332676 19.1804C0.388516 19.2627 0.460144 19.333 0.543396 19.3873C0.626647 19.4416 0.719861 19.4788 0.81762 19.4967C0.915378 19.5147 1.01573 19.513 1.11285 19.4919C1.20996 19.4707 1.3019 19.4304 1.38332 19.3734C1.46473 19.3164 1.53401 19.2438 1.58711 19.1598C2.2681 18.1124 3.19995 17.2517 4.29802 16.6559C5.3961 16.0601 6.62562 15.748 7.87492 15.748C9.12423 15.748 10.3538 16.0601 11.4518 16.6559C12.5499 17.2517 13.4817 18.1124 14.1627 19.1598C14.2727 19.3233 14.4427 19.4369 14.6358 19.4761C14.8289 19.5153 15.0297 19.4769 15.1947 19.3693C15.3598 19.2616 15.4758 19.0934 15.5178 18.9008C15.5598 18.7083 15.5243 18.507 15.419 18.3404C14.3633 16.7154 12.8104 15.4752 10.9921 14.8051ZM3.74992 10.1251C3.74992 9.30924 3.99185 8.51171 4.44511 7.83336C4.89837 7.155 5.54261 6.62629 6.29636 6.31408C7.0501 6.00187 7.8795 5.92018 8.67967 6.07935C9.47984 6.23851 10.2148 6.63138 10.7917 7.20827C11.3686 7.78516 11.7615 8.52017 11.9207 9.32034C12.0798 10.1205 11.9981 10.9499 11.6859 11.7037C11.3737 12.4574 10.845 13.1016 10.1667 13.5549C9.4883 14.0082 8.69077 14.2501 7.87492 14.2501C6.78129 14.2488 5.7328 13.8138 4.95948 13.0405C4.18616 12.2672 3.75117 11.2187 3.74992 10.1251ZM23.4506 19.3782C23.284 19.4868 23.081 19.5249 22.8864 19.4839C22.6918 19.4429 22.5214 19.3263 22.4127 19.1598C21.7326 18.1118 20.8008 17.2507 19.7025 16.6551C18.6042 16.0596 17.3743 15.7484 16.1249 15.7501C15.926 15.7501 15.7352 15.6711 15.5946 15.5304C15.4539 15.3898 15.3749 15.199 15.3749 15.0001C15.3749 14.8012 15.4539 14.6104 15.5946 14.4698C15.7352 14.3291 15.926 14.2501 16.1249 14.2501C16.7324 14.2495 17.3322 14.1148 17.8816 13.8555C18.431 13.5962 18.9163 13.2188 19.3029 12.7502C19.6895 12.2817 19.9678 11.7335 20.118 11.1449C20.2682 10.5563 20.2865 9.94174 20.1716 9.34522C20.0568 8.74871 19.8116 8.18492 19.4536 7.69414C19.0956 7.20337 18.6337 6.79772 18.1007 6.50618C17.5678 6.21464 16.977 6.04441 16.3707 6.00765C15.7643 5.97089 15.1573 6.0685 14.5931 6.29352C14.501 6.33329 14.402 6.35422 14.3018 6.35507C14.2016 6.35591 14.1022 6.33666 14.0095 6.29845C13.9169 6.26024 13.8328 6.20385 13.7623 6.1326C13.6918 6.06135 13.6363 5.9767 13.5991 5.88364C13.5619 5.79058 13.5437 5.691 13.5456 5.59079C13.5475 5.49058 13.5695 5.39177 13.6102 5.3002C13.651 5.20862 13.7097 5.12615 13.7828 5.05764C13.856 4.98913 13.9421 4.93598 14.0362 4.90134C15.3275 4.38632 16.7639 4.36779 18.0681 4.84931C19.3723 5.33083 20.452 6.27829 21.0989 7.50891C21.7458 8.73953 21.914 10.1661 21.5711 11.5134C21.2283 12.8608 20.3986 14.0334 19.2421 14.8051C21.0604 15.4752 22.6133 16.7154 23.669 18.3404C23.7776 18.507 23.8156 18.7099 23.7747 18.9045C23.7337 19.0992 23.6171 19.2695 23.4506 19.3782Z"
                    fill="#00AED9"
                  />
                </svg>
              </div>
            </div>
            <div className="card">
              <div className="title">Verifiers</div>
              <div className="value_group">
                <div className="value">{totalValidators}</div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.125 23.1113C9.9954 23.1112 9.86802 23.0777 9.75525 23.0138L3.38025 19.4025C3.26482 19.3371 3.16881 19.2423 3.102 19.1276C3.0352 19.013 3 18.8827 3 18.75V11.25C3 11.1174 3.0352 10.9871 3.102 10.8724C3.16881 10.7578 3.26482 10.6629 3.38025 10.5975L9.75525 6.98628C9.86803 6.92246 9.99541 6.88892 10.125 6.88892C10.2546 6.88892 10.382 6.92246 10.4948 6.98628L16.8698 10.5975C16.9852 10.6629 17.0812 10.7578 17.148 10.8724C17.2148 10.9871 17.25 11.1174 17.25 11.25V18.75C17.25 18.8827 17.2148 19.013 17.148 19.1276C17.0812 19.2423 16.9852 19.3371 16.8698 19.4025L10.4948 23.0138C10.382 23.0777 10.2546 23.1112 10.125 23.1113ZM4.5 18.3128L10.125 21.4988L15.75 18.3128V11.6873L10.125 8.50128L4.5 11.6865V18.3128Z"
                    fill="#00AED9"
                  />
                  <path
                    d="M20.9996 12.75H19.4996V5.68728L13.8746 2.50128L7.86938 5.90253L7.12988 4.59753L13.5049 0.986282C13.6177 0.922459 13.745 0.888916 13.8746 0.888916C14.0042 0.888916 14.1316 0.922459 14.2444 0.986282L20.6194 4.59753C20.7348 4.66294 20.8308 4.7578 20.8976 4.87243C20.9644 4.98706 20.9996 5.11736 20.9996 5.25003V12.75Z"
                    fill="#00AED9"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div className="card_full register-iot-ipad">
            <div className="title">Register IoT</div>
            <div className="sensor_grid sensor_grid-mini">
              <div className="sensor_title">Sustainability:</div>
              <select
                name=""
                id=""
                value={scenario}
                onChange={(e) => setScenario(e.target.value)}
              >
                {scenario === "" && <option value=""></option>}
                <option value="green-project">Green</option>
                <option value="carbon-monitoring">Carbon Monitoring</option>
                <option value="infrastructure-change">
                  Infrastructure change
                </option>
              </select>
              {/* <div className="sensor_flex">
                <div className="sensor_flex first">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    checked={scenario === "green-project"}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setScenario("green-project");
                      } else {
                        setScenario("");
                      }
                    }}
                  />
                  <div className="sensor_subtitle">Green</div>
                </div>
                <div className="sensor_flex">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    checked={scenario === "carbon-monitoring"}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setScenario("carbon-monitoring");
                      } else {
                        setScenario("");
                      }
                    }}
                  />
                  <div className="sensor_subtitle">Carbon Monitoring</div>
                </div>
                <div className="sensor_flex">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    checked={scenario === "infrastructure-change"}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setScenario("infrastructure-change");
                      } else {
                        setScenario("");
                      }
                    }}
                  />
                  <div className="sensor_subtitle">Infrastructure change</div>
                </div>
              </div> */}
            </div>
            {scenario !== "green-project" && (
              <div className="sensor_grid sensor_grid-mini">
                <div className="sensor_title">Fuel type:</div>
                {/* <div className="sensor_flex">
                  <div className="sensor_flex first">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={fuelType === "Diesel"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFuelType("Diesel");
                        } else {
                          setFuelType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Diesel</div>
                  </div>

                  <div className="sensor_flex">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={fuelType === "natural-gas"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFuelType("natural-gas");
                        } else {
                          setFuelType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Natural Gas</div>
                  </div>
                  <div className="sensor_flex">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={fuelType === "Petrol"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFuelType("Petrol");
                        } else {
                          setFuelType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Petroleum</div>
                  </div>
                  <div className="sensor_flex">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={fuelType === "Coal"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFuelType("Coal");
                        } else {
                          setFuelType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Coal</div>
                  </div>
                </div> */}
                <select
                  name=""
                  id=""
                  value={fuelType}
                  onChange={(e) => setFuelType(e.target.value)}
                >
                  {fuelType === "" && <option value=""></option>}
                  <option value="Diesel">Diesel</option>
                  <option value="natural-gas">Natural Gas</option>
                  <option value="Petrol">Petroleum</option>
                  <option value="Coal">Coal</option>
                </select>
              </div>
            )}
            {/* New baseline energy source dropdown for green-project */}
            {scenario === "green-project" && (
              <div className="sensor_grid sensor_grid-mini">
                <div className="sensor_title">Baseline Energy Source:</div>
                <select
                  name=""
                  id=""
                  value={baselineEnergySource}
                  onChange={(e) => setBaselineEnergySource(e.target.value)}
                >
                  {baselineEnergySource === "" && <option value=""></option>}
                  <option value="Petrol">Petroleum</option>
                  <option value="Diesel">Diesel</option>
                  <option value="Coal">Coal</option>
                  <option value="Natural gas">Natural gas</option>
                  <option value="Kerosene">Kerosene</option>


                </select>
              </div>
            )}

            {scenario === "green-project" && (
              <div className="sensor_grid sensor_grid-mini">
                <div className="sensor_title">Renewable energy source:</div>
                <select
                  name=""
                  id=""
                  value={renewableSource}
                  onChange={(e) => setRenewableSource(e.target.value)}
                >
                  {renewableSource === "" && <option value=""></option>}
                  <option value="hydro-power">Hydro power</option>
                  <option value="solar">solar</option>
                </select>
                {/* <div className="sensor_flex">
                  <div className="sensor_flex first">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={solarType === "utility"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSolarType("utility");
                        } else {
                          setSolarType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Utility</div>
                  </div>
                  <div className="sensor_flex">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={solarType === "roof-top"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSolarType("roof-top");
                        } else {
                          setSolarType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Rooftop</div>
                  </div>
                </div> */}
              </div>
            )}
            {renewableSource === "solar" && (
              <div className="sensor_grid sensor_grid-mini">
                <div className="sensor_title">Solar Type:</div>
                <select
                  name=""
                  id=""
                  value={solarType}
                  onChange={(e) => setSolarType(e.target.value)}
                >
                  {solarType === "" && <option value=""></option>}
                  <option value="utility">Utility</option>
                  <option value="roof-top">Rooftop</option>
                </select>
                {/* <div className="sensor_flex">
                  <div className="sensor_flex first">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={solarType === "utility"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSolarType("utility");
                        } else {
                          setSolarType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Utility</div>
                  </div>
                  <div className="sensor_flex">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={solarType === "roof-top"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSolarType("roof-top");
                        } else {
                          setSolarType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Rooftop</div>
                  </div>
                </div> */}
              </div>
            )}

            <div className="sensor_grid sensor_grid-mini">
              <div className="sensor_title">Subscription:</div>
              <select
                name=""
                id=""
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
              >
                {userType === "" && <option value=""></option>}
                <option value="basic">Basic</option>
                <option value="governance">Governance</option>
                <option value="business">Business</option>
                <option value="business-plus">Business-plus</option>
              </select>
            </div>

            <div className="sensor_grid sensor_grid-mini">
              <div className="sensor_title">Organisation:</div>
              <select
                name=""
                id=""
                value={organization}
                onChange={(e) => setOrganization(e.target.value)}
              >
                {organization === "" && !getUsersLoading ? <option value=""></option> : ""}
                {getUsersLoading &&
                  <option value="">Loading...</option>
                }
                {users?.map((user) => (
                  <option value={user?.id}>{user?.companyName}</option>
                ))}
              </select>
            </div>

            <div className="sensor_button_container">
              <button
                className="sensor_button"
                onClick={handleRegisterDevice}
                disabled={loading}
              >
                {loading ? "Loading..." : "Register"}
              </button>
            </div>

            {modalOpen && (
              <div className="sensor_modal_card">
                <div className="title">Successful</div>
                <div className="subtitle">
                  Sensor as been registered for CloseCarbon (VA), Sensor ID:
                  {sensorId}
                </div>
                <button onClick={() => setModalOpen(false)}>Done</button>
              </div>
            )}
          </div>


          {/* <div className="tasks_card">
            <div className="title">Tasks</div>
          </div> */}

          <div className="total_emission_container">
            <div className="title">Analytics</div>
            <canvas id="total_emission"></canvas>
          </div>

          <div className="offset_credit">
            <div className="card">
              <div className="title">Emission Reduction</div>
              {offsets?.map((facility) => (
                <div className="offset_card">
                  <div className="offset_card_flex">
                    <div className="title">{facility?.companyName}</div>
                    <div className="subtitle">{facility?.offset}tCO2</div>
                  </div>
                  {/* <div className="tag">Renewable energy</div> */}
                  <div className="offset_bar">
                    <div
                      className={
                        facility?.offset > 50
                          ? "itemOne itemOne100"
                          : facility?.offset > 30
                            ? "itemOne itemOne50"
                            : "itemOne itemOne20"
                      }
                    ></div>
                  </div>
                </div>
              ))}
            </div>
            <div className="card">
              <div className="title">CCRT by category</div>
              <div className="creditDoughnutChart">
                <canvas id="doughnutChart"></canvas>
              </div>

              <div className="creditChartFlex">
                <div>23.41%</div>
                <div>Green facility</div>
              </div>
              <div className="creditChartFlex creditChartFlexNonGreen">
                <div>18.13%</div>
                <div>Non-green facility</div>
              </div>
            </div>
          </div>
        </div>

        <div className="main_inner">
          <div className="card_full register-iot-desktop">
            <div className="title">Register IoT</div>
            <div className="sensor_grid sensor_grid-mini">
              <div className="sensor_title">Sustainability:</div>
              <select
                className="px-2"

                name=""
                id=""
                value={scenario}
                onChange={(e) => setScenario(e.target.value)}
              >
                {scenario === "" && <option value=""></option>}
                <option value="green-project">Green</option>
                <option value="carbon-monitoring">Carbon Monitoring</option>
                <option value="infrastructure-change">
                  Infrastructure change
                </option>
              </select>
              {/* <div className="sensor_flex">
                <div className="sensor_flex first">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    checked={scenario === "green-project"}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setScenario("green-project");
                      } else {
                        setScenario("");
                      }
                    }}
                  />
                  <div className="sensor_subtitle">Green</div>
                </div>
                <div className="sensor_flex">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    checked={scenario === "carbon-monitoring"}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setScenario("carbon-monitoring");
                      } else {
                        setScenario("");
                      }
                    }}
                  />
                  <div className="sensor_subtitle">Carbon Monitoring</div>
                </div>
                <div className="sensor_flex">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    checked={scenario === "infrastructure-change"}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setScenario("infrastructure-change");
                      } else {
                        setScenario("");
                      }
                    }}
                  />
                  <div className="sensor_subtitle">Infrastructure change</div>
                </div>
              </div> */}
            </div>
            {scenario !== "green-project" && (
              <div className="sensor_grid sensor_grid-mini">
                <div className="sensor_title">Fuel type:</div>
                {/* <div className="sensor_flex">
                  <div className="sensor_flex first">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={fuelType === "Diesel"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFuelType("Diesel");
                        } else {
                          setFuelType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Diesel</div>
                  </div>

                  <div className="sensor_flex">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={fuelType === "natural-gas"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFuelType("natural-gas");
                        } else {
                          setFuelType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Natural Gas</div>
                  </div>
                  <div className="sensor_flex">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={fuelType === "Petrol"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFuelType("Petrol");
                        } else {
                          setFuelType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Petroleum</div>
                  </div>
                  <div className="sensor_flex">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={fuelType === "Coal"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFuelType("Coal");
                        } else {
                          setFuelType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Coal</div>
                  </div>
                </div> */}
                <select
                  className="px-2"

                  name=""
                  id=""
                  value={fuelType}
                  onChange={(e) => setFuelType(e.target.value)}
                >
                  {fuelType === "" && <option value=""></option>}
                  <option value="Diesel">Diesel</option>
                  <option value="natural-gas">Natural Gas</option>
                  <option value="Petrol">Petroleum</option>
                  <option value="Coal">Coal</option>
                </select>
              </div>
            )}
            {/* Add baseline energy source dropdown here too */}
            {scenario === "green-project" && (
              <div className="sensor_grid sensor_grid-mini">
                <div className="sensor_title ">Baseline Energy Source:</div>
                <select
                  className="px-2"
                  name=""
                  id=""
                  value={baselineEnergySource}
                  onChange={(e) => setBaselineEnergySource(e.target.value)}
                >
                  {baselineEnergySource === "" && <option value=""></option>}
                  <option value="Petrol">Petroleum</option>
                  <option value="Diesel">Diesel</option>
                  <option value="Coal">Coal</option>
                  <option value="Coal">Kerosene</option>
                  <option value="Coal">Natural gas</option>
                </select>
              </div>
            )}

            {scenario === "green-project" && (
              <div className="sensor_grid sensor_grid-mini">
                <div className=" sensor_title ">Renewable energy source:</div>
                <select
                  className="px-2"

                  name=""
                  id=""
                  value={renewableSource}
                  onChange={(e) => setRenewableSource(e.target.value)}
                >
                  {renewableSource === "" && <option value=""></option>}
                  <option value="hydro-power">Hydro power</option>
                  <option value="solar">solar</option>
                </select>
                {/* <div className="sensor_flex">
                  <div className="sensor_flex first">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={solarType === "utility"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSolarType("utility");
                        } else {
                          setSolarType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Utility</div>
                  </div>
                  <div className="sensor_flex">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={solarType === "roof-top"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSolarType("roof-top");
                        } else {
                          setSolarType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Rooftop</div>
                  </div>
                </div> */}
              </div>
            )}
            {renewableSource === "solar" && (
              <div className="sensor_grid sensor_grid-mini">
                <div className="sensor_title">Solar Type:</div>
                <select
                  className="px-2"

                  name=""
                  id=""
                  value={solarType}
                  onChange={(e) => setSolarType(e.target.value)}
                >
                  {solarType === "" && <option value=""></option>}
                  <option value="utility">Utility</option>
                  <option value="roof-top">Rooftop</option>
                </select>
                {/* <div className="sensor_flex">
                  <div className="sensor_flex first">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={solarType === "utility"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSolarType("utility");
                        } else {
                          setSolarType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Utility</div>
                  </div>
                  <div className="sensor_flex">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      checked={solarType === "roof-top"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSolarType("roof-top");
                        } else {
                          setSolarType("");
                        }
                      }}
                    />
                    <div className="sensor_subtitle">Rooftop</div>
                  </div>
                </div> */}
              </div>
            )}

            <div className="sensor_grid sensor_grid-mini">
              <div className="sensor_title">Subscription:</div>
              <select
                className="px-2"

                name=""
                id=""
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
              >
                {userType === "" && <option value=""></option>}
                <option value="basic">Basic</option>
                <option value="governance">Governance</option>
                <option value="business">Business</option>
                <option value="business-plus">Business-plus</option>
              </select>
            </div>

            <div className="sensor_grid sensor_grid-mini">
              <div className="sensor_title">Organisation:</div>
              <select
                className="px-2"

                name=""
                id=""
                value={organization}
                onChange={(e) => setOrganization(e.target.value)}
              >
                {organization === "" && !getUsersLoading ? <option value=""></option> : ""}
                {getUsersLoading &&
                  <option value="">Loading...</option>
                }
                {users?.map((user) => (
                  <option value={user?.id}>{user?.companyName}</option>
                ))}
              </select>
            </div>

            <div className="sensor_button_container">
              <button
                className="sensor_button"
                onClick={handleRegisterDevice}
                disabled={loading}
              >
                {loading ? "Loading..." : "Register"}
              </button>
            </div>

            {modalOpen && (
              <div className="sensor_modal_card">
                <div className="title">Successful</div>
                <div className="subtitle">
                  Sensor as been registered for CloseCarbon (VA), Sensor ID:
                  {sensorId}
                </div>
                <button onClick={() => setModalOpen(false)}>Done</button>
              </div>
            )}
          </div>
          <div className="card_full card_full_max">
            <div className="title_full">Carbon Monitoring and Validation</div>
            <div className="card_nav">
              <div
                className={status === "pending" ? "item item_active" : "item"}
                onClick={() => setStatus("pending")}
              >
                Pending
              </div>
              <div
                className={status === "approved" ? "item item_active" : "item"}
                onClick={() => setStatus("approved")}
              >
                Approved
              </div>
              <div
                className={status === "rejected" ? "item item_active" : "item"}
                onClick={() => setStatus("rejected")}
              >
                Rejected
              </div>
            </div>

            {emissions?.map((emission) => (
              <div className="validation_card">
                <div className="validation_card_inner">
                  <div>
                    {emission?.organizationName.split("")[0]}
                  </div>
                  <div className="validation_items">
                    <div>{emission?.organizationName}</div>
                    <div>
                      {emission?.emissionData?.length > 0 &&
                        ethers.formatEther(
                          emission?.emissionData?.totalGHGEmission?.toString() ? emission?.emissionData?.totalGHGEmission?.toString() : emission?.emissionData?.totalGHGEmissions?.toString()
                        )}
                      tCO2e
                    </div>
                  </div>
                </div>
                <div>Validator 24</div>
              </div>
            ))}
            {emissionLoading && (
              <>
                <div className="validation_card">
                  <Skeleton
                    width={180}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "4px" }}
                  />
                  <Skeleton
                    width={100}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "4px" }}
                  />
                </div>
                <Skeleton
                  width={60}
                  height={20}
                  borderRadius={8}
                  style={{ marginBottom: "28px" }}
                />
                <div className="validation_card">
                  <Skeleton
                    width={180}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "4px" }}
                  />
                  <Skeleton
                    width={100}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "4px" }}
                  />
                </div>
                <Skeleton
                  width={60}
                  height={20}
                  borderRadius={8}
                  style={{ marginBottom: "28px" }}
                />
                <div className="validation_card">
                  <Skeleton
                    width={180}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "4px" }}
                  />
                  <Skeleton
                    width={100}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "8px" }}
                  />
                </div>
                <Skeleton
                  width={60}
                  height={20}
                  borderRadius={8}
                  style={{ marginBottom: "28px" }}
                />
                <div className="validation_card">
                  <Skeleton
                    width={180}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "4px" }}
                  />
                  <Skeleton
                    width={100}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "8px" }}
                  />
                </div>
                <Skeleton
                  width={60}
                  height={20}
                  borderRadius={8}
                  style={{ marginBottom: "28px" }}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {modalOpen && (
        <div className="sensor_modal" onClick={handleModalClose}></div>
      )}
    </div>
  );
};
export default Home;
